import React, { useState } from "react";
import { InlineTableOfContentsProps } from "./InlineTableOfContents";

export const InlineTableOfContentsContext =
  React.createContext<InlineTableOfContentsProps>(
    {} as InlineTableOfContentsProps
  );

const InlineTableOfContentsProvider = ({ children }: any): JSX.Element => {
  const [dataState, setDataState] = useState<any>();
  const [open, setOpen] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<string>("");

  const triggerOpen = (action: boolean) => {
    setOpen(action);
  };

  const setData = (items: any) => {
    setDataState(items);
  };

  const moveToItem = (item: string) => {
    setSelectedItem(item);
  };

  const props: InlineTableOfContentsProps = {
    data: dataState,
    setData,
    triggerOpen,
    openView: open,
    moveToItem,
    selectedItem,
  };

  return (
    <InlineTableOfContentsContext.Provider value={props}>
      {children}
    </InlineTableOfContentsContext.Provider>
  );
};

export default InlineTableOfContentsProvider;
